import { Module } from "../plugins/_application";
import $ from 'jquery';

export default class ContactForm extends Module {

	ready(app) {

    function showLoader () {
      $('.wpcf7-submit-wrap').addClass('loading');
    }

    function hideLoader () {
      $('.wpcf7-submit-wrap').removeClass('loading');
    }

    $('#mtt-wrapper').on('click', '.wpcf7-submit', showLoader);

    document.addEventListener( 'wpcf7submit', function() {
      hideLoader();
    }, false );

  }

}
